<template src="./bracket_measure_units.html">

</template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

export default {
  name: "BracketMeasureUnits",
  data() {
    return {
      alertMsg: '',
      current_id: null,
      currentPage: 1,
      form_data: {
        id: null,
        measure_unit: '',
      },
      id2Delete: null,
      measure_units: [],
      paginatedBracketUM: [],
      perPage: 10,
      selectedUm: {},
      showAlert: false,
      showModal: false,
      total_rows: 0,
    }
  },
  watch: {
    currentPage: {
      handler(newPage, oldPage) {
    
        console.log(`Page changed from ${oldPage} to ${newPage}`)
      }
    },
    perPage: {
      handler(){
      
        this.currentPage = 1
        this.updatePaginatedBracketUM()
      }
    },    
  },   
  async mounted() {

    await this.loadBracketUMsList()
    this.updatePaginatedBracketUM()
  },
  methods: {
    cancelBracketUM() {

      this.current_id = null
      this.form_data = {
        id: null,
        measure_unit: '',
      }
    },
    deleteRecord(id) {

      this.id2Delete = id
      this.showModal = true
    },    
    editRow(bracketUm) {
      
      if(!bracketUm || !bracketUm.measure_unit) {
        
        console.error("measure_unit is not defined in the selected row")
        return
      }

      this.current_id = bracketUm.id
      this.form_data = {
        id: bracketUm.id,
        measure_unit: bracketUm.measure_unit,
      }
    },    
    async handleDelete() {

      try {

        const url = API_URL + "various/BracketMeasureUnitsDetail/"+this.id2Delete+"/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.delete(url, {headers})
        this.showModal = false
        this.current_id = null
        await this.loadBracketUMsList()
        this.updatePaginatedBracketUM( )
      }
      catch(error) {
      
        console.debug("handleDelete() error", error.response) /**/
      
        if(error.response.status == 500) {
        
          this.alertMsg = "Attenzione! L'unità di misura risulta essere utilizzata da almeno una riga di listino. Per rimuoverlo di devono prima rimuovere tutte le righe di listino che utilizzano questa base"
          this.showAlert = true
        }
      }
    },    
    handlePageChange(page) {

      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadBracketUMs()
      })
    },        
    async insertBracketUM() {

      try {

        const url = API_URL+"various/BracketMeasureUnitsDetail/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.post(url, this.form_data, {headers})
        this.cancelBracketUM()
        await this.loadBracketUMsList()
        this.updatePaginatedBracketUM()
      }
      catch(error) {
      
        console.log('Failed to insert measure_unit:', error)
      }            
    },
    async loadBracketUMsList() {

      const url = API_URL + "various/BracketMeasureUnitsList/"
      const axiosInstance = axios.create({
        headers: {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        },
      })
      
      try {

        const response = await axiosInstance.get(url)
        this.measure_units = response.data.map(bracket_unit => ({
          id: bracket_unit.id,
          measure_unit: bracket_unit.measure_unit,
        }))
        this.total_rows = this.measure_units.length
      } 
      catch(error) {
      
        console.log('Failed to load measure_units list:', error)
      }      
    },
    onPageChange(page) {
      
      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadBracketUMsList()
      })
    },    
    onPerPageChange(newPerPage) {
    
      this.perPage = newPerPage
      this.currentPage = 1
      this.loadBracketUMsList()
    },
    onSortChanged(ctx) {
      
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
    },    
    async selectBracketUM(row) {

      this.current_id = row.id
      const url = API_URL+"various/BracketMeasureUnitsDetail/"+row.id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.get(url, {headers: headers})
      this.form_data = response.data
    },    
    async updateBracketUM() {
    
      try {
    
        if(!this.current_id || !this.form_data.measure_unit) {
          
          alert("Please provide a valid measure unit.")
          return
        }
    
        const url = API_URL + "various/BracketMeasureUnitsDetail/" + this.current_id + "/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.patch(url, this.form_data, {headers})
        this.cancelBracketUM()
        await this.loadBracketUMsList()
        this.updatePaginatedBracketUM()
      } 
      catch (error) {
      
        this.alertMsg = "Attenzione! L'aggiornamento dell'unità di misura non è andato a buon fine"
        this.showAlert = true
      }
    },
    async updatePaginatedBracketUM() {

      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      this.paginatedBracketUM = this.measure_units.slice(start, end)
      this.cancelBracketUM()
      this.loadBracketUMsList()
      this.$forceUpdate()
    },
  },
}

</script>
